import * as actions from './blog/actions'
import * as contentful from 'contentful'

const client = contentful.createClient({
	accessToken: '08gd4s4McQvdV2KGWwy6SrhSbfuhcjlHLiRZPmVrJFw',
	space: '4tflcka4vyfn',
})

const error = (err) => console.log(err)

export function loadBlog() {
	return (dispatch) =>
		client
			.getEntries({
				content_type: 'blogPost',
				limit: 10,
				order: '-fields.date',
			})
			.then(({ items }) => {
				dispatch(actions.loadBlogSuccess(items))
			})
			.catch(error)
}
